import { createFileRoute, notFound } from "@tanstack/react-router";

import { LocalePage } from "@/components/locale/LocalePage";
import { localeHead } from "@/lib/locales/head";
import { LOCALES, isLocaleCode } from "@/lib/locales";
import { publicPageHeaders } from "@/lib/http-cache";

export const Route = createFileRoute("/$locale/")({
  headers: publicPageHeaders,
  beforeLoad: ({ params }) => {
    if (!isLocaleCode(params.locale)) throw notFound();
  },
  head: ({ params }) =>
    isLocaleCode(params.locale) ? localeHead(params.locale, "country") : {},
  component: LocaleHome,
});

function LocaleHome() {
  const { locale } = Route.useParams();
  if (!isLocaleCode(locale)) return null;
  return <LocalePage code={locale} pageKey="country" />;
}

void LOCALES;
